import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-driver-details',
  templateUrl: './driver-details.component.html',
  styleUrls: ['./driver-details.component.css']
})
export class DriverDetailsComponent implements OnInit, OnDestroy {
  @Input() entityId: any;
  @Input() widgetData: any;
  driverData: any;
  isloader: boolean = true;
  isError: boolean = false;
  private _getDriverDetailsSubscription: Subscription;

  constructor(private _service: EntitiesServiceService) { }

  ngOnInit(): void {
    this._getDriverDetails();
  }
  ngOnDestroy(): void {
    this._getDriverDetailsSubscription?.unsubscribe();
  }
  private _getDriverDetails() {
    this._getDriverDetailsSubscription = this._service.getDriverDetails({ entityId: this.entityId }).subscribe(
      {
        next: (result: any) => {
          if (result.status) {
            this.driverData = result.response.data[0]?.driverDetails;
            this.isloader = false;
          }
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
          }
        }
      }
    )
  }

}

